import { defineStore } from 'pinia';
import { useHttp } from '@/http/http';  // 自定義的 HTTP 請求函數
import { statusCheck } from '@/store/public'; // 檢查 API 響應狀態的函數
import Swal from 'sweetalert2';

//此pinia用於new cash payment以及處理email,print
export const useCashPaymentStore = defineStore('cashPayment', {
  state: () => ({
    payment: {},
    payments: [],
    document_url: '',
    driverInfo: {
      id:'',
      driverID: '',
      firstName: '',
      lastName: '',
      plateNumber: '',
      licenseFrontUrl: '',
    },
    transactions: [],
    editTransaction: [],
    fees_and_refunds: 0,
    edit_fees_and_refunds: 0,
    totalEntries: 0,
    currentPage: 1,
    currentPageTransactions: 1,
    itemsPerPage: 10,
    itemsPerPageTransactions: 10,
    filters: {
      driverName: '',
      driverID: '',
      plateNumber: '',
      fromDate: '',
      toDate: ''
    },
    selectFromDate: '',  
    selectToDate: '',    
    isDataFetched: false,
    editPageCurrentPageTransactions: 1,
    editPageItemsPerPageTransactions: 10,
    shouldFetchData: true,
    pageSizeOptions: [10, 20, 50, 100], // 新增每頁顯示筆數選項
  }),
  actions: {
    // 獲取付款列表
    async fetchPayments(page = this.currentPage, perPage = this.itemsPerPage) {
      const url = `/api/admin/payment/list`;
      let params = new URLSearchParams();

      params.append('per_page', perPage);
      params.append('page', page);

      const formatDate = (date) => {
        const d = new Date(date);
        let month = '' + (d.getMonth() + 1);
        let day = '' + d.getDate();
        const year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
      };

      if (this.filters.driverName) params.append('driver_name', this.filters.driverName);
      if (this.filters.driverID) params.append('driver_id', this.filters.driverID);
      if (this.filters.plateNumber) params.append('plate_number', this.filters.plateNumber);
      if (this.filters.fromDate) params.append('from', formatDate(this.filters.fromDate));
      if (this.filters.toDate) params.append('to', formatDate(this.filters.toDate));

      try {
        const response = await useHttp().post(`${url}?${params.toString()}`);
        if (statusCheck(response.data)) {
          this.payments = response.data.payments || [];
          this.totalEntries = response.data.total || 0;
          this.currentPage = response.data.current_page || 1;
        } else {
          console.error('Failed to fetch payments:', response.data.message);
        }
      } catch (error) {
        console.error('Error fetching payments:', error);
        throw error;
      }
    },

    // 獲取司機交易記錄
    async fetchDriverTransactions() {
      const url = `/api/admin/payment/driver_transactions`;
      let params = new URLSearchParams();

      const formatDate = (date) => {
        const d = new Date(date);
        let month = '' + (d.getMonth() + 1);
        let day = '' + d.getDate();
        const year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
      };

      if (this.filters.driverID) params.append('driver_id', this.filters.driverID);
      if (this.filters.fromDate) params.append('from', formatDate(this.filters.fromDate));
      if (this.filters.toDate) params.append('to', formatDate(this.filters.toDate));
      if (this.shouldFetchData === false) return;

      try {
        const response = await useHttp().post(`${url}?${params.toString()}`);
        if (statusCheck(response.data)) {
          const data = response.data.data;

          this.driverInfo = {
            id: data.id,
            driverID: data.driver_id,
            firstName: data.first_name,
            middleName: data.middle_name,
            lastName: data.last_name,
            plateNumber: data.plate_number,
            licenseFrontUrl: data.license_front_url,
          };

          this.transactions = data.transactions || [];
          this.fees_and_refunds = data.fees_and_refunds;
          this.totalEntries = data.total_count;
          this.isDataFetched = true;
        } else {
          console.error('Failed to fetch driver transactions:', response.data.message);
        }
      } catch (error) {
        console.error('Error fetching driver transactions:', error);
        throw error;
      }
    },

    // 根據ID獲取單筆付款資訊，專用於編輯頁
    async fetchPaymentById(id) {
      let params = new URLSearchParams();
      params.append('id', id);

      // 使用專門的日期過濾器
      if (this.selectFromDate) params.append('from', this.selectFromDate);
      if (this.selectToDate) params.append('to', this.selectToDate);

      try {
        const response = await useHttp().get(`/api/admin/payment/info?${params.toString()}`);
        if (statusCheck(response.data)) {
          this.payment = response.data.data;
          this.edit_fees_and_refunds = response.data.fees_and_refunds;
          this.document_url = response.data.document_url;
          if (response.data.data.status === 1) {
            this.editTransaction = response.data.data.transactions || [];
          }else{
            this.editTransaction = response.data.data.backup_transactions || [];
          }
          this.totalEntries = this.editTransaction.length;
          this.isDataFetched = true;
        } else {
          console.error('Failed to fetch payment info:', response.data.message);
          return false;
        }
      } catch (error) {
        console.error('Error fetching payment info:', error);
        throw error;
      }
    },

    async createCashPayment(selectedTransactionIds) {
      const url = '/api/admin/payment/create_cash_payment';

      if (!this.driverInfo.id) {
        Swal.fire({
          icon: 'error',
          title: 'Driver ID missing for cash payment',
          showConfirmButton: false,
          timer: 1500,
        });
        return false;
      }

      const payload = {
        transaction_ids: selectedTransactionIds,
        driver_id: this.driverInfo.id
      };

      try {
        const response = await useHttp().post(url, payload);
        if (statusCheck(response.data)) {
          Swal.fire({
            icon: 'success',
            title: response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.fetchPayments(1, 10);
          const payment_id = response.data.payment_id;
          return payment_id;
        } else {
          return false;
        }
      } catch (error) {
        console.error('Error creating cash payment:', error);
        throw error;
      }
    },
    async mailPayments(payment_id) {
      try {
        const response = await useHttp().get(`/api/admin/payment/statment_email?id=${payment_id}`);
        
        // 當成功寄送郵件後，顯示 SweetAlert 訊息
        Swal.fire({
          title: 'Email Sent',
          text: 'The email has been sent. Please check your inbox.',
          icon: 'success',
          confirmButtonText: 'Close', // 用戶必須點擊此按鈕關閉訊息
        });
      } catch (error) {
        console.error('Error sending email:', error);
        
        // 如果發生錯誤，顯示錯誤提示訊息
        Swal.fire({
          title: 'Error',
          text: 'There was an error sending the email. Please try again later.',
          icon: 'error',
          confirmButtonText: 'Close',
        });
      }
    },
    async printPayments(payment_id) {
      try {
        const token = localStorage.getItem('token');

        // 建立一個新的視窗來顯示結果
        const newWindow = window.open('', '_blank');

        // 在新視窗中發送請求，獲取報表頁面
        newWindow.document.write(`
          <html>
            <head>
              <title>Printing</title>
              <script>
                fetch('${process.env.VUE_APP_PUBLIC_PATH}/api/admin/payment/statment_view?id=${payment_id}', {
                  headers: {
                    'Authorization': 'Bearer ${token}'
                  }
                })
                .then(response => response.text())
                .then(data => {
                  document.body.innerHTML = data; // 將結果顯示到新頁面
                })
                .catch(error => console.error('Error:', error));
              </script>
            </head>
            <body>Loading...</body>
          </html>
        `);
      } catch (error) {
        console.error('Error printing payment:', error);
      }
    },
    // 重置司機數據
    resetDriverData() {
      this.driverInfo = {
        driverID: '',
        firstName: '',
        lastName: '',
        plateNumber: '',
        licenseFrontUrl: '',
      };
      this.transactions = [];
      this.editTransaction = [];
      this.isDataFetched = false;
      this.fees_and_refunds = 0,
      // 重置專門的日期過濾器
      this.selectFromDate = '';
      this.selectToDate = '';
      this.shouldFetchData = true; // 重置時允許 API 調用
    },

    // 切換頁碼
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        this.fetchPayments();
      }
    },

    // 切換交易的頁碼
    changeTransactionPage(page) {
      if (page >= 1 && page <= this.totalTransactionPages) {
        this.currentPageTransactions = page;
      }
    },

    // 切換編輯頁面的交易的頁碼
    changeEditPageTransactionPage(page) {
      if (page >= 1 && page <= this.totalEditTransactionPages) {
        this.editPageCurrentPageTransactions = page;
      }
    },
  },
  getters: {
    paginatedData(state) {
      const start = (state.currentPage - 1) * state.itemsPerPage;
      const end = start + state.itemsPerPage;
      return state.payments.slice(start, end);
    },

    paginatedTransactions(state) {
      const start = (state.currentPageTransactions - 1) * state.itemsPerPageTransactions;
      const end = start + state.itemsPerPageTransactions;
      return state.transactions.slice(start, end);
    },

    editPagePaginatedTransactions(state) {
      const start = (state.editPageCurrentPageTransactions - 1) * state.editPageItemsPerPageTransactions;
      const end = start + state.editPageItemsPerPageTransactions;
      return state.editTransaction.slice(start, end);
    },

    totalPages(state) {
      return Math.ceil(state.totalEntries / state.itemsPerPage);
    },

    totalTransactionPages(state) {
      return Math.ceil(state.transactions.length / state.itemsPerPageTransactions);
    },

    totalEditTransactionPages(state) {
      return Math.ceil(state.editTransaction.length / state.editPageItemsPerPageTransactions);
    },

    selectedTransactionsSummary(state) {
      const selectedTransactions = state.transactions.filter(t => t.selected);
      const totalSFV = selectedTransactions.reduce((sum, t) => sum + parseFloat(t.face_value), 0);
      const totalCommissionAmount = selectedTransactions.reduce((sum, t) => sum + parseFloat(t.comm_amount), 0);
      const totalFeesAndRefunds = state.fees_and_refunds;
      const totalAmount = totalSFV + totalCommissionAmount + totalFeesAndRefunds;

      return {
        transactionCount: selectedTransactions.length,
        totalSFV,
        totalCommissionAmount,
        totalFeesAndRefunds,
        totalAmount
      };
    }
  }
});
